// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"ef87c227","21":"5f20ef39","527":"d49cccd1","606":"4cca1134","652":"4cca1134","914":"4cca1134"}[chunkId] + ".chunk.css";
};